<div placement="bottom-right" *ngIf="currentProfile$ | async as currentProfile">
  <sd-tab-bar-item-legacy
    icon="PROFILE"
    [label]="currentProfile.user?.firstName"
    [isActive]="isActive$ | async"
    data-analytics="profile_menu"
  ></sd-tab-bar-item-legacy>

  <div data-analytics="login_menu">
    <div class="dropdown-login-menu">
      <ng-container *ngIf="currentProfile.isLoggedIn; else anonymousMenu">
        <ng-container *ngIf="currentProfile.isLegal">
          <sd-collapsible-text
            class="menu-title"
            [textContent]="currentProfile.name"
            [lineClamp]="3"
            [disabled]="true"
          ></sd-collapsible-text>

          <a sdLink [routerLink]="{ cxRoute: 'companiesList' } | cxUrl">Личный кабинет</a>
          <a sdLink *ngIf="currentProfile.bonusBalance" [routerLink]="{ cxRoute: 'bonus' } | cxUrl">
            <span>
              {{ currentProfile.bonusBalance.segmentName ? currentProfile.bonusBalance.segmentName : 'Баллы' }}
            </span>

            <sd-bonus-widget class="dropdown-bonus" [amount]="currentProfile.bonusBalance.value"></sd-bonus-widget>
          </a>
        </ng-container>

        <ng-container *ngIf="!currentProfile.isLegal">
          <span class="menu-title">{{ currentProfile.name }}</span>
          <a sdLink [routerLink]="{ cxRoute: 'orders' } | cxUrl">Личный кабинет</a>
          <a
            sdLink
            *ngIf="
              currentProfile.bonusBalance &&
              (currentProfile.bonusBalance.value || currentProfile.bonusBalance.value === 0)
            "
            [routerLink]="{ cxRoute: 'bonus' } | cxUrl"
          >
            <span>
              {{ currentProfile.bonusBalance.segmentName ? currentProfile.bonusBalance.segmentName : 'Баллы' }}
            </span>
            <sd-bonus-widget class="dropdown-bonus" [amount]="currentProfile.bonusBalance.value"></sd-bonus-widget>
          </a>
        </ng-container>
        <hr />

        <ng-container *ngIf="currentProfile.companies">
          <ng-container *ngIf="currentProfile.companies.length > 0">
            <div class="companies-list">
              <div class="menu-subtitle">
                <span>Мои компании</span>
              </div>

              <a sdLink *ngFor="let company of currentProfile.companies" (click)="selectCompany(company.uid)">
                <sd-collapsible-text
                  class="menu-title"
                  [textContent]="company.name"
                  [lineClamp]="3"
                  [disabled]="true"
                ></sd-collapsible-text>
              </a>

              <sd-add-company-button action="redirect" size="xs"></sd-add-company-button>

              <ng-container *ngIf="currentProfile.isLegal">
                <hr />
                <a sdLink (click)="resetSelectedCompany()">
                  {{ currentProfile.user.name }}
                </a>
              </ng-container>
            </div>
            <hr />
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #anonymousMenu>
        <a sdButton type="primary" [routerLink]="{ cxRoute: 'login' } | cxUrl" data-analytics="btn_login">
          <span>Войти</span>
        </a>

        <a sdLink [routerLink]="{ cxRoute: 'login' } | cxUrl" class="registration" data-analytics="to_registration">
          Зарегистрироваться
        </a>
      </ng-template>

      <button sdButton *ngIf="currentProfile.isLoggedIn" type="outlined" (click)="logout()">Выйти</button>
    </div>
  </div>
</div>
